<section class="payment-table">
  <div class="payment-table__header">
    <div>
      <p class="payment-table__eyebrow">{{ 'PAYMENT_TABLE.EYEBROW' | translate }}</p>
      <h3>{{ 'PAYMENT_TABLE.HEADER' | translate }}</h3>
      <p>{{ 'PAYMENT_TABLE.SUBTITLE' | translate }}</p>
    </div>

    <div class="payment-table__toggle">
      <span [class.payment-table__toggle-label--active]="billingInterval === 'monthly'">
        {{ 'PAYMENT_TABLE.BILLING_MONTHLY' | translate }}
      </span>
      <button mat-stroked-button type="button" (click)="toggleBillingInterval()">
        <mat-icon>swap_horiz</mat-icon>
      </button>
      <span [class.payment-table__toggle-label--active]="billingInterval === 'yearly'">
        {{ 'PAYMENT_TABLE.BILLING_YEARLY' | translate }}
      </span>
    </div>
  </div>

  <div class="payment-table__cards">
    <mat-card
      *ngFor="let plan of plans; trackBy: trackByPlan"
      class="payment-card"
      [class.payment-card--popular]="plan.popular && !isCurrentPlan(plan)"
      [class.payment-card--current]="isCurrentPlan(plan)"
      [class.payment-card--preselected]="preselectedPlan?.priceId === plan.priceId"
    >
      <div class="payment-card__preselect-badge" *ngIf="preselectedPlan?.priceId === plan.priceId">
        {{ 'PAYMENT_TABLE.PRESELECTED' | translate }}
      </div>
      <div class="payment-card__badge" *ngIf="plan.popular && !isCurrentPlan(plan)">
        {{ 'PAYMENT_TABLE.POPULAR' | translate }}
      </div>

      <mat-card-content class="payment-card__content">
        <div class="payment-card__headline">
          <p class="payment-card__kicker">{{ plan.kicker }}</p>
          <h4>{{ plan.name }}</h4>
          <p>{{ plan.description }}</p>
        </div>

        <div class="payment-card__price">
          <div class="payment-card__price-main">
            <span class="payment-card__price-amount">{{ plan.priceLabel }}</span>
            <span *ngIf="plan.priceId !== 'FREE'" class="payment-card__price-unit">{{ 'PAYMENT_TABLE.PRICE_PER_MONTH' | translate }}</span>
          </div>
          <small *ngIf="plan.priceId !== 'FREE'" class="payment-card__price-sub">
            {{ plan.billingInterval === 'year'
              ? ('PAYMENT_TABLE.PRICE_SUB_YEARLY' | translate)
              : ('PAYMENT_TABLE.PRICE_SUB_MONTHLY' | translate) }}
          </small>
          <small *ngIf="plan.priceId !== 'FREE' && plan.alternativePrice" class="payment-card__comparison">
            {{ plan.alternativeInterval === 'year'
              ? ('PAYMENT_TABLE.ALTERNATIVE_YEARLY' | translate:{price: plan.alternativePrice})
              : ('PAYMENT_TABLE.ALTERNATIVE_MONTHLY' | translate:{price: plan.alternativePrice}) }}
          </small>
          <small *ngIf="plan.priceId !== 'FREE' && plan.yearlySavings && plan.billingInterval !== 'year'" class="payment-card__savings">
            {{ 'PAYMENT_TABLE.YEARLY_SAVINGS' | translate:{amount: plan.yearlySavings} }}
          </small>
          <small *ngIf="plan.priceId !== 'FREE' && plan.yearlySavings && plan.billingInterval === 'year'" class="payment-card__savings payment-card__savings--active">
            {{ 'PAYMENT_TABLE.YEARLY_SAVINGS' | translate:{amount: plan.yearlySavings} }}
          </small>
          <small *ngIf="plan.priceId !== 'FREE'" class="payment-card__tax-note">{{ 'PAYMENT_TABLE.TAX_NOTE' | translate }}</small>
        </div>

        <ul class="payment-card__features">
          <li *ngFor="let feature of plan.features">
            <mat-icon>check</mat-icon>
            <span>
              {{ feature.label }}
              <small *ngIf="feature.detail" class="payment-card__feature-detail">{{ feature.detail }}</small>
            </span>
          </li>
        </ul>
      </mat-card-content>

      <mat-card-actions class="payment-card__actions">
        <button
          mat-flat-button
          color="accent"
          class="payment-card__cta docuty-cta"
          [disabled]="isCurrentPlan(plan)"
          (click)="onSelectPlan(plan)"
        >
          {{ isCurrentPlan(plan) ? ('PAYMENT_TABLE.CURRENT_PLAN' | translate) : plan.ctaLabel }}
        </button>
        <p class="payment-card__cta-note">
          {{ plan.startsTrial
              ? ('PAYMENT_TABLE.TRIAL_NOTE' | translate)
              : (plan.requiresCheckout
                  ? ('PAYMENT_TABLE.CHECKOUT_NOTE' | translate)
                  : ('PAYMENT_TABLE.FREE_NOTE' | translate)) }}
        </p>
      </mat-card-actions>
    </mat-card>
  </div>

  <p class="payment-table__footnote">
    {{ 'PAYMENT_TABLE.FOOTNOTE' | translate }}
  </p>
</section>
